/**************************************************
 * Nombre:
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {ButtonBase, Grid2, Typography} from "@mui/material";
import {useNavigate} from "react-router-dom";
import logo from "../../Recursos/logo_barra.svg";
import {theme} from "../../Tema";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import {WhatsApp} from "@mui/icons-material";
import {LINKWHATSAPP, SECCIONES} from "../../Constantes";
import {irUrl} from "../../Utilidades/irUrl";
import {marcarEvento} from "../../Servicios/Analiticas/marcarEvento";


const BarraPc = () => {
    const navigate = useNavigate()
    const {sCell} = useResponsive()

    return (
        <Grid2
            container
            justifyContent={'center'}
            alignItems={'center'}
            size={12}
            position="absolute"
            sx={{background: 'transparent', mt: 3, px: 2}}
        >
            <Grid2 container
                   justifyContent={'center'}
                   size={12}
                   sx={{maxWidth: "1400px", px: 3}}
            >

                <Grid2 container size={4} sx={{mt: 2}}>
                    <img
                        onClick={() => navigate('/Home')}
                        src={logo} width={'50%'} height={'auto'}
                        style={{cursor: 'pointer'}}
                    />
                </Grid2>

                <Grid2 container size={{xs: 2, sm: 2, md: 2}}>

                </Grid2>

                <Grid2 container size={6}
                       sx={{backgroundColor: 'white', borderRadius: 10}}
                >

                    <Grid2 container
                           justifyContent={'space-between'}
                           alignItems={'center'}
                           size={8}
                           sx={{color: 'black', px: 6, py: 3}}
                    >

                        {SECCIONES.map((it) => (

                            <Typography
                                key={it}
                                onClick={() => navigate('/' + it.replaceAll(" ", "_"))}
                                sx={{
                                    display: 'block',
                                    fontSize: 16,
                                    fontWeight: 600,
                                    cursor: 'pointer',
                                    borderBottom: 2,
                                    pt: 0.5,
                                    borderColor: '#00000000',
                                    transition: 'color 0.3s ease',
                                    '&:hover': {
                                        color: theme.palette.primary.main,
                                        borderBottom: 2
                                    },
                                }}
                            >
                                {it}
                            </Typography>

                        ))}
                    </Grid2>

                    <Grid2 container
                           justifyContent={'center'}
                           alignItems={'center'}
                           size={4}
                           sx={{
                               backgroundColor: theme.palette.primary.main, color: 'white', borderTopRightRadius: 40,
                               borderBottomRightRadius: 40,
                           }}
                    >
                        <ButtonBase
                            onClick={() => {
                                irUrl(LINKWHATSAPP)
                                marcarEvento('btn_whatsapp')
                            }
                            }
                            color={'action'}
                            sx={{
                                width: '100%',
                                height: '100%',
                                paddingY: 0.5,
                                cursor: 'pointer',
                                transition: 'color 0.3s ease',
                                '&:hover': {
                                    color: "#000",
                                },
                                borderBottomRightRadius: 40,
                                borderTopRightRadius: 40
                            }}
                        >
                            <WhatsApp/>

                            <Typography
                                sx={{fontWeight: 600, pl: 2}}
                            >
                                Más Información
                            </Typography>

                        </ButtonBase>
                    </Grid2>

                </Grid2>

            </Grid2>

        </Grid2>

    )

}
export default BarraPc;